<template>
  <div class="p-2 d-flex flex-column justify-content-center">
    <div class="indicators">
      <!-- <div class="indicators-item">
        <span class="indicators-item-color bg-purple"></span>
        <label class="indicators-item-text" for>{{ $t('attendanceCalendar.absent') }}</label>
      </div> -->
      <div class="indicators-item ml-4">
        <span class="indicators-item-color bg-green"></span>
        <label class="indicators-item-text" for>{{ $t('attendanceCalendar.attend') }}</label>
      </div>
    </div>
    <v-calendar
      ref="calendar"
      :attributes="attributes"
      :columns="$screens({ xl: 6, lg: 4, sm: 1 })"
      :rows="$screens({ xl: 2, lg: 3, sm: 2 })"
      :is-expanded="$screens({ xl: true, lg: false, sm: true })"
      class="mx-auto"
      :locale="$store.state.language"
      @update:from-page="fromPage"
      @update:to-page="toPage"
      @daymouseenter="onDay"
    >
      <div slot="day-popover" slot-scope="{ day, dayTitle }">
        <div class="text-xs text-gray-300 font-semibold text-center">
          {{ dayTitle }}
          <div>
            <button type="button" class="btn btn-outline-info btn-sm" @click="onActivityReport">
              {{ $t('attendanceCalendar.showActivityReport') }}
            </button>
          </div>
        </div>
      </div>
    </v-calendar>
    <Modal :show-modal="showActivityReport" @close="showActivityReport = false">
      <template slot="modalHeader">{{ $t('children.showActivityTimeTitle') }}</template>
      <template slot="modalBody">
        <ActivityList :student-id="studentId" :show-filters="false" :date-range="selectedDateRange" />
      </template>
      <template slot="modalFooter">
        <!-- <button type="button" class="btn btn-secondary" @click="showActivityReport = false">
          Close
        </button> -->
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import ActivityList from './ActivityList.vue';
import Modal from '@/components/Modal.vue';

export default {
  name: 'AttendanceCalendar',
  components: {
    ActivityList,
    Modal,
  },
  props: {
    studentId: {
      type: Number,
      required: true,
    },
    studentCreatedAt: {
      type: Date,
      required: true,
    },
  },
  data() {
    let todos = [
      {
        description: '',
        isComplete: false,
        dates: [],
        color: 'green',
        isInteractive: true,
      },
      {
        description: '',
        isComplete: false,
        dates: [],
        color: 'purple',
        isInteractive: false,
      },
    ];
    return {
      incId: todos.length,
      todos,
      selectedDateRange: {
        from: moment().startOf('month').format('YYYY-MM-DD hh:mm'),
        to: moment().endOf('month').format('YYYY-MM-DD hh:mm'),
      },
      showActivityReport: false,
      dialogVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      sessions: 'session/list',
    }),
    attributes() {
      return [
        // Attributes for todos
        ...this.todos.map(todo => ({
          dates: todo.dates,
          highlight: {
            color: todo.color,
            fillMode: 'light',
          },
          popover: {
            label: todo.description,
            isInteractive: todo.isInteractive,
          },
          customData: todo,
        })),
        // {
        //   key: 'today',
        //   highlight: {
        //     color: 'purple',
        //     fillMode: 'light'
        //   },
        //   popover: {
        //     label: 'You just hovered over today\'s date!'
        //   },
        //   dates: new Date()
        // }
      ];
    },
  },
  watch: {},
  created() {
    //this.onFetchSessions();
    //this.todos[1].dates = this.getDates(this.studentCreatedAt, new Date());
    this.todos[0].dates = this.getDatesStudent();
    console.log('dates', this.getDatesStudent());
  },
  mounted() {
    const calendar = this.$refs.calendar;
    const page = { month: 1, year: moment().year() };
    // Pass a page ({ month, year })
    calendar.showPageRange(page);
  },
  methods: {
    ...mapActions({
      fetchSessions: 'session/FETCH_LIST',
    }),
    isInArray(array, value) {
      return (
        (
          array.find(item => {
            return item === value;
          }) || []
        ).length > 0
      );
    },
    // Returns an array of dates between the two dates
    getDates(startDate, endDate) {
      let dates = [];
      let currentDate = startDate;
      let addDays = function (days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };
      while (currentDate <= endDate) {
        dates.push(moment(currentDate).format('YYYY/MM/DD'));
        currentDate = addDays.call(currentDate, 1);
      }
      return dates;
    },
    getDatesStudent() {
      let dates = [];
      this.$httpMain
        .post(`assistance-lesson-traking`, {
          student_id: this.studentId,
        })
        .then(res => {
          _.forEach(res.data, function (date) {
            dates.push(moment(date.created_at).format('YYYY-MM-DD'));
          });
        })
        .catch(err => {
          console.log(err);
        });
      return dates;
    },
    onFetchSessions() {
      var self = this;
      this.$store.commit('START_PROCESSING');
      this.fetchSessions({
        term: 'date-range',
        filters: {
          from: this.selectedDateRange.from,
          to: this.selectedDateRange.to,
          student_id: this.studentId,
        },
      })
        .then(res => {
          let sessions = _.uniqBy(res.data.items, function (e) {
            return moment(e.created_at).format('YYYY/MM/DD');
          });

          _.forEach(sessions, function (session) {
            self.todos[0].dates.push(moment(session.created_at).format('YYYY/MM/DD'));

            // eliminates the dates where the user created activity if it exists otherwise notifies that the user did not attend
            if (self.isInArray(self.todos[1].dates, moment(session.created_at).format('YYYY/MM/DD'))) {
              _.remove(self.todos[1].dates, function (date) {
                return date === moment(session.created_at).format('YYYY/MM/DD');
              });
            }
          });
          // console.log(self.todos[1].dates)
          this.$store.commit('STOP_PROCESSING');
        })
        .catch(() => {
          this.$store.commit('STOP_PROCESSING');
        });
    },
    onActivityReport() {
      this.showActivityReport = true;
    },
    fromPage(page) {
      if (!page) return;
      var { month, year } = page;
      var date = new Date(year, month - 1);
      this.selectedDateRange.from = moment(date).startOf('months').format('YYYY-MM-DD hh:mm');
    },
    toPage(page) {
      if (!page) return;
      var { month, year } = page;
      var date = new Date(year, month - 1);
      this.selectedDateRange.to = moment(date).endOf('months').format('YYYY-MM-DD hh:mm');
      //this.onFetchSessions();
    },
    onDay(day) {
      this.selectedDateRange.from = moment(day.date).startOf('day').toDate();
      this.selectedDateRange.to = moment(day.date).endOf('day').toDate();
    },
  },
};
</script>
<style lang="scss" scoped>
.indicators {
  font-family: 'comfortaabold';
  display: flex;
  justify-content: flex-end;
  padding-top: 1em;
  padding-bottom: 1em;
}
.indicators-item {
  display: flex;
  align-items: center;
}
.indicators-item-color {
  display: block;
  width: 35px;
  height: 35px;
  margin-right: 1em;
  border-radius: 0.5em;
}
.indicators-item-color.bg-green {
  background-color: #c7f6d6;
}
.indicators-item-color.bg-purple {
  background-color: #e9d7fd;
}
</style>
